<template>
  <section
    v-if="heroInfo"
    id="hero"
  >
    <v-img
      :src="heroInfo.fields.background.fields.file.url"
      class="white--text hero-image"
      :gradient="`to right, rgba(${rgba}), rgba(${rgba})`"
    >
      <v-container
        class="fill-height px-4 py-12"
      >
        <v-responsive
          class="d-flex align-center"
          height="100%"
          max-width="700"
          width="100%"
        >
          <base-heading :title="heroInfo.fields.headline" />

          <base-body color="white">
            <rich-text-renderer
              :document="heroInfo.fields.subheadline"
            />
          </base-body>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
  export default {
    name: 'SectionHero',

    provide: {
      theme: { isDark: true },
    },

    data () {
      return {
        heroInfo: null,
        rgba: [5, 11, 31, 0.3],
      }
    },

    async mounted () {
      const { items } = await this.$contentful.getEntries({
        content_type: 'hero',
        select: 'fields',
      })
      const [entry] = items
      this.heroInfo = entry
    },
  }
</script>

<style lang="scss" scoped>
.hero-image {
  height: 100vh;
}
@media only screen and (max-width: 600px) {
  .hero-image {
    height: 50vh;
  }
}
p.base-body p {
  display: inline-block;
  text-shadow: 2px 2px 2px hsla(0, 0%, 0%, 0.8);
}
</style>
